<script>
    import { onMount } from "svelte";
    import { FormGroup, Input } from "sveltestrap";
    import store from "../store";
    import l from "../utils/locale";

    export let id;
    let isDrawStrokeDash = false;
    let isRound = false;
    let isScaleStroke = false;

    onMount(() => {
        return store.subscribe((s) => {
            if (id === "frame") {
                isDrawStrokeDash = s.isDrawStrokeDashFrame;
                isRound = s.drawStrokeLineCapFrame === "round";
            } else {
                isDrawStrokeDash = s.isDrawStrokeDash;
                isRound = s.drawStrokeLineCap === "round";
            }
        });
    });

    function onInputHandlerChecked(e) {
        let v = e.target.checked;
        if (e.target.name === "drawStrokeLineCap") {
            const _isRound = v ? "round" : "butt";
            if (id === "frame") {
                store.setValue("drawStrokeLineCapFrame", _isRound);
            } else {
                store.setValue("drawStrokeLineCap", _isRound);
            }
        } else {
            if (id === "frame") {
                store.setValue(e.target.name + "Frame", v);
            } else {
                store.setValue(e.target.name, v);
            }
        }
    }
</script>

<div>
    <FormGroup>
        <Input
            id="drawStrokeLineCap"
            name="drawStrokeLineCap"
            type="checkbox"
            label={l["rounded"]}
            bind:checked={isRound}
            on:change={onInputHandlerChecked}
        />
    </FormGroup>
    <FormGroup>
        <Input
            id="isDrawStrokeDash"
            name="isDrawStrokeDash"
            type="checkbox"
            label={l["dotted"]}
            bind:checked={isDrawStrokeDash}
            on:change={onInputHandlerChecked}
        />
    </FormGroup>
</div>
